/**
 * Custom Javascript Code for Theme.
 *
 * @author Eberhard Lauth
 *
 */
( function ( $ ) {
    /**
     * Re-Initialize Foundation's equalizer on window.load.
     * Because equalizing doesn't work in firefox e.g. without this fix.
     */
    $( window ).load( function() {
        if ( Foundation.Equalizer.length ) {
            Foundation.reInit( 'equalizer' );
        }
    } );

    /* Off canvas Hamburger Toggle */

    $(document).on('opened.zf.offCanvas', function () {
        $('button.hamburger').addClass('is-active');
    });

    $(document).on('closed.zf.offCanvas', function () {
        $('button.hamburger').removeClass('is-active');
    });

    /* Comment form reply link handling */
    $('a.comment-reply-link').on('click', function() {
        $(this).hide();
    });
    $('a#cancel-comment-reply-link').on('click', function() {
        $('a.comment-reply-link').show();
    });

    /* Abide for Gforms */

    // Toggle Abide Validation Message on complex input fields like address or name
    // Scroll to first invalid input

    $(document).on('invalid.zf.abide', function(ev) {
        // case invalid
        if ($('#'+ev.target.id).closest('.ginput_complex').length) {
            // Toggle error message on complex input fields
            $('.form-error.' + $('#'+ev.target.id).closest('.ginput_complex').attr('id')).addClass('is-visible');
        }
        // Show snackbar ...
        var msg = $('.snackbar-msg.submit-error').text();
        Snackbar.show({
            text: msg,
            pos: 'bottom-left',
            showAction: false,
        });

        // ... and scroll to first invalid input
        Foundation.SmoothScroll.scrollToLoc('.is-invalid-input', {
            animationDuration: 750,
            animationEasing: 'swing',
            threshold: 40,
            offset: 80
        });

    });
    $(document).on('valid.zf.abide', function(ev) {
        // case valid
        if ($('#'+ev.target.id).closest('.ginput_complex').length) {
            $('.form-error.' + $('#' + ev.target.id).closest('.ginput_complex').attr('id')).removeClass('is-visible');
        }
    });

    $(document).ready(function(){
        var host = window.location.host;
        var origin = window.location.origin;
        if ( host == 'staging.netzkundig.com') {
            $('body.not-homepage .off-canvas .menu li a').each(function(){
                var anchor = $(this).attr('href'); // Get current url
                var url = origin+'/ag-rohstoffe/'+anchor; // Create new url
                $(this).attr('href', url); // Set href value
            });
            $('body.not-homepage .top-bar-right .menu li a').each(function(){
                var anchor = $(this).attr('href'); // Get current url
                var url = origin+'/ag-rohstoffe/'+anchor; // Create new url
                $(this).attr('href', url); // Set href value
            });
            /*$('body.not-homepage .off-canvas a.button').each(function(){
                var anchor = $(this).attr('href'); // Get current url
                var url = origin+'/ag-rohstoffe/'+anchor; // Create new url
                $(this).attr('href', url); // Set href value
            });
            $('body.not-homepage .meta-menu a.button').each(function(){
                var anchor = $(this).attr('href'); // Get current url
                var url = origin+'/ag-rohstoffe/'+anchor; // Create new url
                $(this).attr('href', url); // Set href value
            });*/
        } else {
            $('body.not-homepage .off-canvas .menu li a').each(function(){
                var anchor = $(this).attr('href'); // Get current url
                var url = origin+'/'+anchor; // Create new url
                $(this).attr('href', url); // Set href value
            });
            $('body.not-homepage .top-bar-right .menu li a').each(function(){
                var anchor = $(this).attr('href'); // Get current url
                var url = origin+'/'+anchor; // Create new url
                $(this).attr('href', url); // Set href value
            });
            /*$('body.not-homepage .off-canvas a.button').each(function(){
                var anchor = $(this).attr('href'); // Get current url
                var url = origin+'/'+anchor; // Create new url
                $(this).attr('href', url); // Set href value
            });
            $('body.not-homepage .meta-menu a.button').each(function(){
                var anchor = $(this).attr('href'); // Get current url
                var url = origin+'/'+anchor; // Create new url
                $(this).attr('href', url); // Set href value
            });*/
        }

    });

    $( '.wp-block-latest-posts.is-grid .wp-block-latest-posts__featured-image img' ).wrap(function() {
        return '<a class="post-grid-link"></a>';
    });

    $('.wp-block-latest-posts.is-grid .wp-block-latest-posts__featured-image').click(function() {
        window.location = $(this).next().attr('href');
        return false;
    });

} )( jQuery );
